var _style, _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgMenuModules(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1440 796",
    style: {
      enableBackground: "new 0 0 1440 796"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000038395771989839869360000008757857682129052092_);}\n\t.st1{fill:#2537A8;}\n\t.st2{opacity:0.2;fill:url(#SVGID_00000150786354104979653800000015059410152881141136_);enable-background:new    ;}\n\t.st3{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:1;stroke-miterlimit:4;}\n\t.st4{opacity:0.1;fill:url(#SVGID_00000006678354006509263020000016856571673083383457_);enable-background:new    ;}\n\t.st5{opacity:0.1;fill:url(#SVGID_00000038389265148833706300000010796218210625462157_);enable-background:new    ;}\n\t.st6{opacity:0.1;fill:url(#SVGID_00000081645459936985192720000014722035249900223876_);enable-background:new    ;}\n\t.st7{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 1440,
    height: 796
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003070687802737117120000009775035851138697607_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003070687802737117120000009775035851138697607_)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 1440,
    height: 796
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009576511445126050800000012364839557983912591_",
    gradientUnits: "userSpaceOnUse",
    x1: 1139.9644,
    y1: 617.1756,
    x2: 251.5784,
    y2: -390.4585,
    gradientTransform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1106.6597 -10.9133)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00127704,
    style: {
      stopColor: "#2537A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1CEAB6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000009576511445126050800000012364839557983912591_)",
      enableBackground: "new"
    },
    d: " M441-502.2l-850.9,850.9c-27.3,27.3-27.3,71.7,0,99L441,1298.5c27.3,27.3,71.7,27.3,99,0l850.9-850.9c27.3-27.3,27.3-71.7,0-99 L540-502.2C512.7-529.5,468.4-529.5,441-502.2z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M441.4-502.1l-850.9,850.9c-27.1,27.1-27.1,71.1,0,98.3l850.9,850.9c27.1,27.1,71.1,27.1,98.3,0L1390.5,447 c27.1-27.1,27.1-71.1,0-98.3L539.7-502.1C512.5-529.3,468.5-529.3,441.4-502.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018199138312974960610000003390503565310891931_",
    gradientUnits: "userSpaceOnUse",
    x1: 1139.9644,
    y1: 617.1756,
    x2: 251.5784,
    y2: -390.4585,
    gradientTransform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 693.0977 -10.9133)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00127704,
    style: {
      stopColor: "#2537A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1CEAB6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "url(#SVGID_00000018199138312974960610000003390503565310891931_)",
      enableBackground: "new"
    },
    d: " M27.5-502.2l-850.9,850.9c-27.3,27.3-27.3,71.7,0,99l850.9,850.9c27.3,27.3,71.7,27.3,99,0l850.9-850.9c27.3-27.3,27.3-71.7,0-99 L126.5-502.2C99.1-529.5,54.8-529.5,27.5-502.2z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.8-502.1L-823,348.7c-27.1,27.1-27.1,71.1,0,98.3l850.9,850.9c27.1,27.1,71.1,27.1,98.3,0L977,447 c27.1-27.1,27.1-71.1,0-98.3L126.1-502.1C99-529.3,55-529.3,27.8-502.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178182715366899188120000016234087338047464602_",
    gradientUnits: "userSpaceOnUse",
    x1: 1139.9644,
    y1: 617.1756,
    x2: 251.5784,
    y2: -390.4585,
    gradientTransform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 279.5366 -10.9133)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00127704,
    style: {
      stopColor: "#2537A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1CEAB6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "url(#SVGID_00000178182715366899188120000016234087338047464602_)",
      enableBackground: "new"
    },
    d: " M-386.1-502.2l-850.9,850.9c-27.3,27.3-27.3,71.7,0,99l850.9,850.9c27.3,27.3,71.7,27.3,99,0l850.9-850.9 c27.3-27.3,27.3-71.7,0-99l-850.9-850.9C-314.4-529.5-358.7-529.5-386.1-502.2z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-385.7-502.1l-850.9,850.9c-27.1,27.1-27.1,71.1,0,98.3l850.9,850.9c27.1,27.1,71.1,27.1,98.3,0L563.4,447 c27.1-27.1,27.1-71.1,0-98.3l-850.9-850.9C-314.6-529.3-358.6-529.3-385.7-502.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149375176765301322950000005771955794560070555_",
    gradientUnits: "userSpaceOnUse",
    x1: 1139.9644,
    y1: 617.1756,
    x2: 251.5784,
    y2: -390.4585,
    gradientTransform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 -134.0254 -11.2053)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00127704,
    style: {
      stopColor: "#2537A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1CEAB6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "url(#SVGID_00000149375176765301322950000005771955794560070555_)",
      enableBackground: "new"
    },
    d: " M-799.6-502.5l-850.9,850.9c-27.3,27.3-27.3,71.7,0,99l850.9,850.9c27.3,27.3,71.7,27.3,99,0l850.9-850.9 c27.3-27.3,27.3-71.7,0-99l-850.9-850.9C-728-529.8-772.3-529.8-799.6-502.5z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-799.3-502.1l-850.9,850.9c-27.1,27.1-27.1,71.1,0,98.3l850.9,850.9c27.1,27.1,71.1,27.1,98.3,0L149.9,447 c27.1-27.1,27.1-71.1,0-98.3L-701-502.1C-728.1-529.3-772.1-529.3-799.3-502.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1351.6,790.8c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1351,791,1351.3,790.8,1351.6,790.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1351.6,777.9c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1351.3,777.9,1351.6,777.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1351.6,763.9c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1351.3,763.9,1351.6,763.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1351.6,749.8c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1351.3,749.8,1351.6,749.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1351.6,735.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1351,735.4,1351.3,735.7,1351.6,735.7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1351.6,721.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1351,721.4,1351.3,721.7,1351.6,721.7z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1351.6,707.6c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1351.3,707.6,1351.6,707.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1351.6,692.4c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1351.3,692.4,1351.6,692.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1351.6,679.5c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1351,679.2,1351.3,679.5,1351.6,679.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1351.6,664.3c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1351,664.6,1351.3,664.3,1351.6,664.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1351.6,651.4c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1351.3,651.4,1351.6,651.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1351.6,637.4c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1351.3,637.4,1351.6,637.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1351.6,623.3c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1351.3,623.3,1351.6,623.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1351.6,609.3c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1351.3,609.3,1351.6,609.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1351.6,595.2c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1351,594.9,1351.3,595.2,1351.6,595.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1339.6,790.8c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1339,791,1339.3,790.8,1339.6,790.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1339.6,777.9c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1339.3,777.9,1339.6,777.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1339.6,763.9c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1339.3,763.9,1339.6,763.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1339.6,749.8c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1339.3,749.8,1339.6,749.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1339.6,735.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1339,735.4,1339.3,735.7,1339.6,735.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1339.6,721.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1339,721.4,1339.3,721.7,1339.6,721.7z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1339.6,707.6c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1339.3,707.6,1339.6,707.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1339.6,692.4c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1339.3,692.4,1339.6,692.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1339.6,679.5c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1339,679.2,1339.3,679.5,1339.6,679.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1339.6,664.3c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1339,664.6,1339.3,664.3,1339.6,664.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1339.6,651.4c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1339.3,651.4,1339.6,651.4z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1339.6,637.4c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1339.3,637.4,1339.6,637.4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1339.6,623.3c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1339.3,623.3,1339.6,623.3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1339.6,609.3c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1339.3,609.3,1339.6,609.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1339.6,595.2c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1339,594.9,1339.3,595.2,1339.6,595.2z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1327.6,790.8c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1327,791,1327.3,790.8,1327.6,790.8z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1327.6,777.9c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1327.3,777.9,1327.6,777.9z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1327.6,763.9c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1327.3,763.9,1327.6,763.9z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1327.6,749.8c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1327.3,749.8,1327.6,749.8z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1327.6,735.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1327,735.4,1327.3,735.7,1327.6,735.7z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1327.6,721.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1327,721.4,1327.3,721.7,1327.6,721.7z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1327.6,707.6c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1327.3,707.6,1327.6,707.6z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1327.6,692.4c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1327.3,692.4,1327.6,692.4z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1327.6,679.5c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1327,679.2,1327.3,679.5,1327.6,679.5z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1327.6,664.3c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1327,664.6,1327.3,664.3,1327.6,664.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1327.6,651.4c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1327.3,651.4,1327.6,651.4z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1327.6,637.4c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1327.3,637.4,1327.6,637.4z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1327.6,623.3c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1327.3,623.3,1327.6,623.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1327.6,609.3c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1327.3,609.3,1327.6,609.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1327.6,595.2c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1327,594.9,1327.3,595.2,1327.6,595.2z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1363.6,790.8c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1363,791,1363.3,790.8,1363.6,790.8z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1363.6,777.9c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1363.3,777.9,1363.6,777.9z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1363.6,763.9c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1363.3,763.9,1363.6,763.9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1363.6,749.8c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1363.3,749.8,1363.6,749.8z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1363.6,735.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1363,735.4,1363.3,735.7,1363.6,735.7z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1363.6,721.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1363,721.4,1363.3,721.7,1363.6,721.7z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1363.6,707.6c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1363.3,707.6,1363.6,707.6z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1363.6,692.4c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1363.3,692.4,1363.6,692.4z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1363.6,679.5c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1363,679.2,1363.3,679.5,1363.6,679.5z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1363.6,664.3c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1363,664.6,1363.3,664.3,1363.6,664.3z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1363.6,651.4c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1363.3,651.4,1363.6,651.4z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1363.6,637.4c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1363.3,637.4,1363.6,637.4z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1363.6,623.3c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1363.3,623.3,1363.6,623.3z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1363.6,609.3c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1363.3,609.3,1363.6,609.3z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1363.6,595.2c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1363,594.9,1363.3,595.2,1363.6,595.2z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1375.6,790.8c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1375,791,1375.3,790.8,1375.6,790.8z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1375.6,777.9c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1375.3,777.9,1375.6,777.9z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1375.6,763.9c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1375.3,763.9,1375.6,763.9z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1375.6,749.8c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1375.3,749.8,1375.6,749.8z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1375.6,735.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1375,735.4,1375.3,735.7,1375.6,735.7z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1375.6,721.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1375,721.4,1375.3,721.7,1375.6,721.7z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1375.6,707.6c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1375.3,707.6,1375.6,707.6z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1375.6,692.4c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1375.3,692.4,1375.6,692.4z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1375.6,679.5c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1375,679.2,1375.3,679.5,1375.6,679.5z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1375.6,664.3c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1375,664.6,1375.3,664.3,1375.6,664.3z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1375.6,651.4c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1375.3,651.4,1375.6,651.4z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1375.6,637.4c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1375.3,637.4,1375.6,637.4z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1375.6,623.3c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1375.3,623.3,1375.6,623.3z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1375.6,609.3c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1375.3,609.3,1375.6,609.3z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1375.6,595.2c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1375,594.9,1375.3,595.2,1375.6,595.2z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1387.6,790.8c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1387,791,1387.3,790.8,1387.6,790.8z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1387.6,777.9c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1387.3,777.9,1387.6,777.9z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1387.6,763.9c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1387.3,763.9,1387.6,763.9z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1387.6,749.8c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1387.3,749.8,1387.6,749.8z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1387.6,735.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1387,735.4,1387.3,735.7,1387.6,735.7z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1387.6,721.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1387,721.4,1387.3,721.7,1387.6,721.7z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1387.6,707.6c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1387.3,707.6,1387.6,707.6z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1387.6,692.4c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1387.3,692.4,1387.6,692.4z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1387.6,679.5c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1387,679.2,1387.3,679.5,1387.6,679.5z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1387.6,664.3c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1387,664.6,1387.3,664.3,1387.6,664.3z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1387.6,651.4c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1387.3,651.4,1387.6,651.4z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1387.6,637.4c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1387.3,637.4,1387.6,637.4z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1387.6,623.3c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1387.3,623.3,1387.6,623.3z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1387.6,609.3c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1387.3,609.3,1387.6,609.3z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1387.6,595.2c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1387,594.9,1387.3,595.2,1387.6,595.2z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.6,790.8c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1399,791,1399.3,790.8,1399.6,790.8z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.6,776.7c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1399.3,776.7,1399.6,776.7z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.6,762.6c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1399.3,762.6,1399.6,762.6z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.6,748.6c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1399.3,748.6,1399.6,748.6z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.6,734.5c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1399,734.8,1399.3,734.5,1399.6,734.5z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.6,720.5c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1399,720.8,1399.3,720.5,1399.6,720.5z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.6,706.4c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1399.3,706.4,1399.6,706.4z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.6,692.4c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1399.3,692.4,1399.6,692.4z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.6,678.3c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1399,678.6,1399.3,678.3,1399.6,678.3z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.6,664.3c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1399,664.6,1399.3,664.3,1399.6,664.3z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.6,650.2c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1399.3,650.2,1399.6,650.2z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.6,636.2c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1399,636.4,1399.3,636.2,1399.6,636.2z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.6,622.1c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1399.3,622.1,1399.6,622.1z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.6,608.1c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1399,608.3,1399.3,608.1,1399.6,608.1z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.6,594c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1399,594.3,1399.3,594,1399.6,594z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1411.6,790.8c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1411,791,1411.3,790.8,1411.6,790.8z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1411.6,776.7c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1411.3,776.7,1411.6,776.7z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1411.6,762.6c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1411.3,762.6,1411.6,762.6z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1411.6,748.6c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1411.3,748.6,1411.6,748.6z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1411.6,734.5c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1411,734.8,1411.3,734.5,1411.6,734.5z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1411.6,720.5c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1411,720.8,1411.3,720.5,1411.6,720.5z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1411.6,706.4c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1411.3,706.4,1411.6,706.4z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1411.6,692.4c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1411.3,692.4,1411.6,692.4z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1411.6,678.3c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1411,678.6,1411.3,678.3,1411.6,678.3z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1411.6,664.3c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1411,664.6,1411.3,664.3,1411.6,664.3z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1411.6,650.2c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1411.3,650.2,1411.6,650.2z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1411.6,636.2c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1411,636.4,1411.3,636.2,1411.6,636.2z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1411.6,622.1c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1411.3,622.1,1411.6,622.1z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1411.6,608.1c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1411,608.3,1411.3,608.1,1411.6,608.1z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1411.6,594c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1411,594.3,1411.3,594,1411.6,594z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1423.6,790.8c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1423,791,1423.3,790.8,1423.6,790.8z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1423.6,776.7c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1423.3,776.7,1423.6,776.7z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1423.6,762.6c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1423.3,762.6,1423.6,762.6z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1423.6,748.6c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1423.3,748.6,1423.6,748.6z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1423.6,734.5c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1423,734.8,1423.3,734.5,1423.6,734.5z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1423.6,720.5c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1423,720.8,1423.3,720.5,1423.6,720.5z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1423.6,706.4c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1423.3,706.4,1423.6,706.4z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1423.6,692.4c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1423.3,692.4,1423.6,692.4z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1423.6,678.3c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1423,678.6,1423.3,678.3,1423.6,678.3z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1423.6,664.3c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1423,664.6,1423.3,664.3,1423.6,664.3z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1423.6,650.2c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1423.3,650.2,1423.6,650.2z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1423.6,636.2c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1423,636.4,1423.3,636.2,1423.6,636.2z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1423.6,622.1c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1423.3,622.1,1423.6,622.1z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1423.6,608.1c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1423,608.3,1423.3,608.1,1423.6,608.1z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1423.6,594c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1423,594.3,1423.3,594,1423.6,594z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1435.6,790.8c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1435,791,1435.3,790.8,1435.6,790.8z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1435.6,777.9c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1435.3,777.9,1435.6,777.9z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1435.6,763.9c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1435.3,763.9,1435.6,763.9z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1435.6,749.8c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1435.3,749.8,1435.6,749.8z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1435.6,735.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1435,735.4,1435.3,735.7,1435.6,735.7z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1435.6,721.7c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1435,721.4,1435.3,721.7,1435.6,721.7z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1435.6,707.6c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1435.3,707.6,1435.6,707.6z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1435.6,692.4c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6S1435.3,692.4,1435.6,692.4z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1435.6,679.5c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1435,679.2,1435.3,679.5,1435.6,679.5z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1435.6,664.3c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6 C1435,664.6,1435.3,664.3,1435.6,664.3z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1435.6,651.4c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1435.3,651.4,1435.6,651.4z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1435.6,637.4c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1435.3,637.4,1435.6,637.4z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1435.6,623.3c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1435.3,623.3,1435.6,623.3z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1435.6,609.3c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6S1435.3,609.3,1435.6,609.3z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1435.6,595.2c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6 C1435,594.9,1435.3,595.2,1435.6,595.2z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1426.8,153.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1427,154,1426.8,153.7,1426.8,153.4z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1413.9,153.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1413.6,154,1413.9,153.7,1413.9,153.4z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.9,153.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1399.6,154,1399.9,153.7,1399.9,153.4z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1385.8,153.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1385.5,154,1385.8,153.7,1385.8,153.4z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1371.7,153.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1371.4,154,1371.7,153.7,1371.7,153.4z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1357.7,153.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1357.4,154,1357.7,153.7,1357.7,153.4z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1343.6,153.4c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6S1343.6,153.7,1343.6,153.4z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1328.4,153.4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6S1328.4,153.7,1328.4,153.4z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1315.5,153.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1315.2,154,1315.5,153.7,1315.5,153.4z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1300.3,153.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1300.6,154,1300.3,153.7,1300.3,153.4z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1287.4,153.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1287.1,154,1287.4,153.7,1287.4,153.4z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1273.4,153.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1273.1,154,1273.4,153.7,1273.4,153.4z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1259.3,153.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1259,154,1259.3,153.7,1259.3,153.4z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1245.3,153.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1245,154,1245.3,153.7,1245.3,153.4z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1231.2,153.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1230.9,154,1231.2,153.7,1231.2,153.4z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1426.8,165.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1427,166,1426.8,165.7,1426.8,165.4z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1413.9,165.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1413.6,166,1413.9,165.7,1413.9,165.4z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.9,165.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1399.6,166,1399.9,165.7,1399.9,165.4z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1385.8,165.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1385.5,166,1385.8,165.7,1385.8,165.4z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1371.7,165.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1371.4,166,1371.7,165.7,1371.7,165.4z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1357.7,165.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1357.4,166,1357.7,165.7,1357.7,165.4z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1343.6,165.4c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6S1343.6,165.7,1343.6,165.4z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1328.4,165.4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6S1328.4,165.7,1328.4,165.4z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1315.5,165.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1315.2,166,1315.5,165.7,1315.5,165.4z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1300.3,165.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1300.6,166,1300.3,165.7,1300.3,165.4z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1287.4,165.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1287.1,166,1287.4,165.7,1287.4,165.4z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1273.4,165.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1273.1,166,1273.4,165.7,1273.4,165.4z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1259.3,165.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1259,166,1259.3,165.7,1259.3,165.4z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1245.3,165.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1245,166,1245.3,165.7,1245.3,165.4z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1231.2,165.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1230.9,166,1231.2,165.7,1231.2,165.4z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1426.8,177.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1427,178,1426.8,177.7,1426.8,177.4z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1413.9,177.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1413.6,178,1413.9,177.7,1413.9,177.4z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.9,177.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1399.6,178,1399.9,177.7,1399.9,177.4z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1385.8,177.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1385.5,178,1385.8,177.7,1385.8,177.4z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1371.7,177.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1371.4,178,1371.7,177.7,1371.7,177.4z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1357.7,177.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1357.4,178,1357.7,177.7,1357.7,177.4z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1343.6,177.4c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6S1343.6,177.7,1343.6,177.4z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1328.4,177.4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6S1328.4,177.7,1328.4,177.4z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1315.5,177.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1315.2,178,1315.5,177.7,1315.5,177.4z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1300.3,177.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1300.6,178,1300.3,177.7,1300.3,177.4z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1287.4,177.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1287.1,178,1287.4,177.7,1287.4,177.4z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1273.4,177.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1273.1,178,1273.4,177.7,1273.4,177.4z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1259.3,177.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1259,178,1259.3,177.7,1259.3,177.4z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1245.3,177.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1245,178,1245.3,177.7,1245.3,177.4z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1231.2,177.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1230.9,178,1231.2,177.7,1231.2,177.4z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1426.8,141.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1427,142,1426.8,141.7,1426.8,141.4z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1413.9,141.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1413.6,142,1413.9,141.7,1413.9,141.4z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.9,141.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1399.6,142,1399.9,141.7,1399.9,141.4z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1385.8,141.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1385.5,142,1385.8,141.7,1385.8,141.4z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1371.7,141.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1371.4,142,1371.7,141.7,1371.7,141.4z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1357.7,141.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1357.4,142,1357.7,141.7,1357.7,141.4z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1343.6,141.4c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6S1343.6,141.7,1343.6,141.4z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1328.4,141.4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6S1328.4,141.7,1328.4,141.4z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1315.5,141.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1315.2,142,1315.5,141.7,1315.5,141.4z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1300.3,141.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1300.6,142,1300.3,141.7,1300.3,141.4z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1287.4,141.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1287.1,142,1287.4,141.7,1287.4,141.4z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1273.4,141.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1273.1,142,1273.4,141.7,1273.4,141.4z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1259.3,141.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1259,142,1259.3,141.7,1259.3,141.4z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1245.3,141.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1245,142,1245.3,141.7,1245.3,141.4z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1231.2,141.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1230.9,142,1231.2,141.7,1231.2,141.4z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1426.8,129.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1427,130,1426.8,129.7,1426.8,129.4z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1413.9,129.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1413.6,130,1413.9,129.7,1413.9,129.4z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.9,129.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1399.6,130,1399.9,129.7,1399.9,129.4z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1385.8,129.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1385.5,130,1385.8,129.7,1385.8,129.4z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1371.7,129.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1371.4,130,1371.7,129.7,1371.7,129.4z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1357.7,129.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1357.4,130,1357.7,129.7,1357.7,129.4z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1343.6,129.4c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6S1343.6,129.7,1343.6,129.4z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1328.4,129.4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6S1328.4,129.7,1328.4,129.4z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1315.5,129.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1315.2,130,1315.5,129.7,1315.5,129.4z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1300.3,129.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1300.6,130,1300.3,129.7,1300.3,129.4z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1287.4,129.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1287.1,130,1287.4,129.7,1287.4,129.4z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1273.4,129.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1273.1,130,1273.4,129.7,1273.4,129.4z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1259.3,129.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1259,130,1259.3,129.7,1259.3,129.4z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1245.3,129.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1245,130,1245.3,129.7,1245.3,129.4z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1231.2,129.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6 C1230.9,130,1231.2,129.7,1231.2,129.4z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1426.8,117.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1427,118,1426.8,117.7,1426.8,117.4z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1413.9,117.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1413.6,118,1413.9,117.7,1413.9,117.4z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.9,117.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1399.6,118,1399.9,117.7,1399.9,117.4z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1385.8,117.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1385.5,118,1385.8,117.7,1385.8,117.4z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1371.7,117.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1371.4,118,1371.7,117.7,1371.7,117.4z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1357.7,117.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1357.4,118,1357.7,117.7,1357.7,117.4z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1343.6,117.4c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6S1343.6,117.7,1343.6,117.4z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1328.4,117.4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6S1328.4,117.7,1328.4,117.4z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1315.5,117.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1315.2,118,1315.5,117.7,1315.5,117.4z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1300.3,117.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1300.6,118,1300.3,117.7,1300.3,117.4z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1287.4,117.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1287.1,118,1287.4,117.7,1287.4,117.4z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1273.4,117.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1273.1,118,1273.4,117.7,1273.4,117.4z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1259.3,117.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1259,118,1259.3,117.7,1259.3,117.4z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1245.3,117.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1245,118,1245.3,117.7,1245.3,117.4z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1231.2,117.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1230.9,118,1231.2,117.7,1231.2,117.4z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1426.8,105.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1427,106,1426.8,105.7,1426.8,105.4z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1412.7,105.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1413,106,1412.7,105.7,1412.7,105.4z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1398.6,105.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1398.9,106,1398.6,105.7,1398.6,105.4z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1384.6,105.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1384.9,106,1384.6,105.7,1384.6,105.4z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1370.5,105.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1370.8,106,1370.5,105.7,1370.5,105.4z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1356.5,105.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1356.8,106,1356.5,105.7,1356.5,105.4z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1342.4,105.4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6S1342.4,105.7,1342.4,105.4z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1328.4,105.4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6S1328.4,105.7,1328.4,105.4z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1314.3,105.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1314.6,106,1314.3,105.7,1314.3,105.4z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1300.3,105.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1300.6,106,1300.3,105.7,1300.3,105.4z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1286.2,105.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1286.5,106,1286.2,105.7,1286.2,105.4z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1272.2,105.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1272.4,106,1272.2,105.7,1272.2,105.4z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1258.1,105.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1258.4,106,1258.1,105.7,1258.1,105.4z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1244.1,105.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1244.3,106,1244.1,105.7,1244.1,105.4z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1230,105.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1230.3,106,1230,105.7,1230,105.4z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1426.8,93.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1427,94,1426.8,93.7,1426.8,93.4z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1412.7,93.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1413,94,1412.7,93.7,1412.7,93.4z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1398.6,93.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1398.9,94,1398.6,93.7,1398.6,93.4z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1384.6,93.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1384.9,94,1384.6,93.7,1384.6,93.4z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1370.5,93.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1370.8,94,1370.5,93.7,1370.5,93.4z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1356.5,93.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1356.8,94,1356.5,93.7,1356.5,93.4z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1342.4,93.4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6S1342.4,93.7,1342.4,93.4z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1328.4,93.4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6S1328.4,93.7,1328.4,93.4z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1314.3,93.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1314.6,94,1314.3,93.7,1314.3,93.4z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1300.3,93.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1300.6,94,1300.3,93.7,1300.3,93.4z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1286.2,93.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1286.5,94,1286.2,93.7,1286.2,93.4z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1272.2,93.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1272.4,94,1272.2,93.7,1272.2,93.4z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1258.1,93.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1258.4,94,1258.1,93.7,1258.1,93.4z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1244.1,93.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1244.3,94,1244.1,93.7,1244.1,93.4z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1230,93.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1230.3,94,1230,93.7,1230,93.4z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1426.8,81.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1427,82,1426.8,81.7,1426.8,81.4z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1412.7,81.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1413,82,1412.7,81.7,1412.7,81.4z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1398.6,81.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1398.9,82,1398.6,81.7,1398.6,81.4z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1384.6,81.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1384.9,82,1384.6,81.7,1384.6,81.4z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1370.5,81.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1370.8,82,1370.5,81.7,1370.5,81.4z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1356.5,81.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1356.8,82,1356.5,81.7,1356.5,81.4z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1342.4,81.4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6S1342.4,81.7,1342.4,81.4z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1328.4,81.4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6S1328.4,81.7,1328.4,81.4z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1314.3,81.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1314.6,82,1314.3,81.7,1314.3,81.4z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1300.3,81.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1300.6,82,1300.3,81.7,1300.3,81.4z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1286.2,81.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1286.5,82,1286.2,81.7,1286.2,81.4z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1272.2,81.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1272.4,82,1272.2,81.7,1272.2,81.4z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1258.1,81.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1258.4,82,1258.1,81.7,1258.1,81.4z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1244.1,81.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1244.3,82,1244.1,81.7,1244.1,81.4z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1230,81.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1230.3,82,1230,81.7,1230,81.4z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1426.8,69.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1427,70,1426.8,69.7,1426.8,69.4z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1413.9,69.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1413.6,70,1413.9,69.7,1413.9,69.4z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1399.9,69.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1399.6,70,1399.9,69.7,1399.9,69.4z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1385.8,69.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1385.5,70,1385.8,69.7,1385.8,69.4z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1371.7,69.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1371.4,70,1371.7,69.7,1371.7,69.4z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1357.7,69.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1357.4,70,1357.7,69.7,1357.7,69.4z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1343.6,69.4c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6S1343.6,69.7,1343.6,69.4z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1328.4,69.4c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6S1328.4,69.7,1328.4,69.4z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1315.5,69.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1315.2,70,1315.5,69.7,1315.5,69.4z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1300.3,69.4c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6 C1300.6,70,1300.3,69.7,1300.3,69.4z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1287.4,69.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1287.1,70,1287.4,69.7,1287.4,69.4z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1273.4,69.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1273.1,70,1273.4,69.7,1273.4,69.4z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1259.3,69.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6C1259,70,1259.3,69.7,1259.3,69.4 z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1245.3,69.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6C1245,70,1245.3,69.7,1245.3,69.4 z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1231.2,69.4c0-0.3-0.3-0.6-0.6-0.6c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6 C1230.9,70,1231.2,69.7,1231.2,69.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgMenuModules);
export default __webpack_public_path__ + "static/media/bg-menu-modules.8e3fd9e60b019d746d313e6eb7e9c449.svg";
export { ForwardRef as ReactComponent };